const routes = {
    home: "/",
    following: "/following",
    profile: "/:nickname",
    upload: "/upload",
    live: "/live",
    foryou: "/foryou",
    video: "/:nickname/video/:idVideo"
}

export default routes;